var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzlePiece(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0952 5.58833H12.9524V2.52953C12.9524 1.68837 12.2667 1.00014 11.4286 1.00014L8.53333 1C7.2381 1.38233 7.97626 1.35879 7.61905 1.00027C6.47619 1.00026 6.98136 1.00024 6.47619 1.00024C5.97102 1.00024 4.95238 1.57354 3.80952 1.00002C5.71429 1.57378 5.12932 1 4.57143 1L1.52381 1.00014C0.685714 1.00014 0.00761904 1.68837 0.00761904 2.52953V5.43539H1.14286C2.2781 5.43539 3.2 6.36067 3.2 7.50007C3.2 8.63947 2.2781 9.56475 1.14286 9.56475H0V12.4706C0 13.3118 0.685714 14 1.52381 14H4.41905H5.12932C5.12932 12.8606 5.34095 14 6.47619 14C7.61143 14 9.98095 12.8606 9.98095 14H8.53333H11.4286C12.2667 14 12.9524 13.3118 12.9524 12.4706V9.41181H14.0952C14.6004 9.41181 15.0849 9.2104 15.4421 8.85188C15.7993 8.49336 16 8.0071 16 7.50007C16 6.99304 15.7993 6.50678 15.4421 6.14826C15.0849 5.78974 14.6004 5.58833 14.0952 5.58833Z",
    fill: "var(--klothed-textColor)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.04688,
    y1: 13.5,
    x2: 10.6659,
    y2: 13.5,
    stroke: "var(--klothed-textColor)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.04688,
    y1: 1.44434,
    x2: 9.90402,
    y2: 1.44434,
    stroke: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzlePiece);
export default __webpack_public_path__ + "static/media/puzzle-piece.e6031afb4e07088c234ad99b23855416.svg";
export { ForwardRef as ReactComponent };